import { useState, Suspense, lazy } from 'react';
import useCommonJson from "./useCommonJson";
import { useParams} from 'react-router-dom';

const FormModal = lazy(() => import('../BorrowerLeadForm/BorrowerLeadForm')); 

const useFormModal = () => {
  const [show, setShow] = useState(false);
  const [validate, setValidate] = useState(false);
  const [modalData, setModalData] = useState(null);
  const { loName } = useParams();
  const loCommonData = useCommonJson(loName);
 
  const handleClick = (link) => {
    setModalData(link); // Store the link for the modal
    setValidate((validate) => !validate);
    setShow((show) => !show);
  };

  // Function to render the modal
  const renderModal = () => (
    <Suspense fallback={<div></div>}>
      {show && (
        <FormModal
          show={show}
          buttonClicked={handleClick}
          validate={validate}
          data={modalData} 
          modalData={modalData}
          loCommonData= {loCommonData}  
        />
      )}
    </Suspense>
  );

  return { handleClick, renderModal };
};

export default useFormModal;
